/** 首批 35 个例画与题库的明确绑定。此文件不导入仅服务端可用的题库。 */
export const ORIGINAL_EXAMPLE_WORD_IDS: Record<string, string[]> = {
  cat: ['zh-9'], panda: ['zh-30'], sunflower: ['zh-36'], strawberry: ['zh-8'],
  icecream: ['zh-3'], house: ['zh-157'], boat: ['zh-24'], balloon: ['zh-43'],
  rocket: ['zh-150'], fish: ['zh-12'], rabbit: ['zh-11'], penguin: ['zh-29'],
  turtle: ['zh-14'], butterfly: ['zh-13'], snail: ['zh-32'], mushroom: ['zh-67'],
  watermelon: ['zh-2'], umbrella: ['zh-18'], whale: ['zh-314'], lighthouse: ['zh-38'],
  fox: ['zh-300'], swan: ['zh-325'], dolphin: ['zh-97'], jellyfish: ['zh-105'],
  owl: ['zh-98'], lotus: ['zh-461'], rose: ['zh-203'], cherry: ['zh-208'],
  cactus: ['zh-35'], grapes: ['zh-60'], castle: ['zh-37'], windmill: ['zh-163'],
  piano: ['zh-210'], bicycle: ['zh-21'], coffee: ['zh-71'],
};
